export default __webpack_public_path__ + "static/media/change-password.2a1e5067.svg";